// ── Transport types (match backend DTOs exactly) ────────────────────────────

export interface LC_WorkingDayTypeItemOut {
  id: number;
  description: string | null;
}

export type LC_GetWorkingDayTypesListOut = LC_WorkingDayTypeItemOut[];

// ── Internal domain model ──────────────────────────────────────────────────

export interface WorkingDayType {
  id: number;
  description: string;
}

/**
 * Ids estables del catálogo DTtipojornada — nunca discriminar tipo de jornada por texto
 * (el texto es solo para mostrar en UI, puede cambiar de redacción).
 */
export const WORKING_DAY_TYPE_ID = {
  FIXED: 1,
  BY_SHIFT: 2,
  DISTRIBUTED_CYCLES: 3,
  BIWEEKLY: 4,
  PARTIAL: 5,
  EXCEPTIONAL: 6,
} as const;
